import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Layers } from 'lucide-react';
import { getBuildChoiceGuide } from '../data/buildChoiceGuides';

/**
 * Compact "related Build Choices" strip for weaving the decision guides into
 * timeline, cost and comparison pages (internal-link mesh). Pass an array of
 * guide slugs; unknown slugs are skipped.
 */
export default function BuildChoicesStrip({ slugs = [], title = 'Decisions to get right', subtitle }) {
  const guides = slugs.map(getBuildChoiceGuide).filter(Boolean);
  if (guides.length === 0) return null;
  return (
    <section className="py-12 sm:py-16 bg-[#f5f8ff] border-y border-[#1d8efe]/10" data-testid="build-choices-strip">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between gap-4 mb-6">
          <div>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1d1d1f] tracking-tight">{title}</h2>
            {subtitle && <p className="text-[14px] text-[#52525b] mt-1.5 max-w-2xl">{subtitle}</p>}
          </div>
          <Link to="/build-choices" className="hidden sm:inline-flex items-center gap-1.5 text-sm font-semibold text-[#1d8efe] no-underline whitespace-nowrap" data-testid="build-choices-strip-all">
            All Build Choices <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {guides.map((g) => (
            <Link
              key={g.slug}
              to={`/build-choices/${g.slug}`}
              className="group flex items-center justify-between gap-2 bg-white border border-gray-200 rounded-xl px-4 py-3 hover:border-[#1d8efe]/40 hover:shadow-sm transition-all no-underline"
              data-testid={`build-choices-strip-${g.slug}`}
            >
              <span className="text-[14px] font-medium text-[#1d1d1f] group-hover:text-[#1d8efe] leading-snug">{g.h1}</span>
              <ArrowRight className="w-4 h-4 text-[#86868b] shrink-0 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
